import React from 'react';
import * as Ui from './styles';
import { RadioButton } from '../../../RadioButton';
import { CheckButton } from '../../../CheckButton';
import { IconButton } from '../../../IconButton';
import { TrashIcon, EditIcon } from '../../../Icons';

/**
 *
 * @param {*} dark para estilizar uma opção quando o selector está dentro de um fundo branco
 * @param {*} inputName Nome a ser utilizaco no input, caso esteja sendo utilizado diretamente em um formulario
 * @param {*} index posicao do input no grupo de inputs
 * @param {*} label label a ser exibido no input
 * @param {*} value valor do input
 * @param {*} type tipo do input (radio | checkbox)
 * @param {*} isChecked marcacao se o input inicia selecionado ou nao
 * @param {*} isRemovable apresenta o botão de remover caso seja verdadeiro (default=false)
 * @param {*} onChange callback para tratar o evento de selecao
 * @param {*} onTrash callback para tratar o evento de acionamento do botão de remoção da opção
 * @param {*} theme tema atual
 */
export default function Option({
  dark,
  inputName = '',
  index,
  label,
  value,
  type = 'radio',
  isChecked = false,
  isRemovable = false,
  isEditalble = false,
  withIcon = true,
  onChange,
  onTrash,
  onEdit,
  theme,
}) {
  function handleChange() {
    if (onChange) onChange({ dark, inputName, label, value, index, isChecked: !isChecked });
  }

  function handleTrashClick() {
    if (onTrash) onTrash({ dark, inputName, label, value, index, isChecked: !isChecked });
  }

  function handleEditClick() {
    if (onEdit) onEdit({ dark, inputName, label, value, index, isChecked: !isChecked });
  }

  return (
    <Ui.Container className={dark ? 'option-wrapper dark' : 'option-wrapper'} withIcon={withIcon}>
      <div className="option-label">
        <div className="option-label-content">
          {type === 'radio' ? (
            <RadioButton
              dark={dark}
              value={value}
              checked={isChecked}
              name={inputName}
              onChange={handleChange}
              label={label}
            />
          ) : (
            <CheckButton
              dark={dark}
              value={value}
              checked={isChecked}
              name={inputName}
              onChange={handleChange}
              label={label}
            />
          )}
        </div>
        {isEditalble ? (
          <IconButton iconColor={theme.colors.menuItemTextColor} iconComponent={EditIcon} iconSize={15} onClick={handleEditClick} />
        ) : null }
        {isRemovable ? (
          <IconButton iconColor={theme.colors.menuItemTextColor} iconComponent={TrashIcon} iconSize={15} onClick={handleTrashClick} />
        ) : null }
      </div>
    </Ui.Container>
  );
}
